import React from "react";
import { Button } from "../../../components/ui/common/button";
import { ActionButtonConfig } from "../types";

interface ProductSummaryHeaderProps {
  actionButtons: ActionButtonConfig[];
  showButtons: boolean;
  onButtonAction: (id: number) => void;
}

/**
 * ProductSummaryHeader Component
 * Single Responsibility: Header with title and action buttons
 */
export const ProductSummaryHeader: React.FC<ProductSummaryHeaderProps> = ({
  actionButtons,
  showButtons,
  onButtonAction
}) => {
  return (
    <div className="tw-flex tw-items-center tw-justify-between">
      <h1 className="tw-text-xl tw-font-display tw-font-bold tw-text-primary">Product Summary</h1>
      {showButtons && (
        <div className="tw-flex tw-items-center tw-gap-2">
          {actionButtons.map(({ id, label, icon: Icon, variant }) => (
            <Button
              key={id}
              size="lg"
              variant={variant === "outline" ? "outline" : undefined}
              onClick={() => onButtonAction(id)}
              className="tw-bg-primary hover:tw-bg-primary/90 tw-text-primary-foreground tw-text-xs tw-gap-1.5"
            >
              <Icon className="tw-h-3.5 tw-w-3.5" />
              {label}
            </Button>
          ))}
        </div>
      )}
    </div>
  );
};
